import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasOptions, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { UserOrgsSlideoutComponent } from './user-orgs-slideout/user-orgs-slideout.component';
import { filter, map, switchMap, tap } from 'rxjs';
import { UsersAdminService } from '../../services/users-admin.service';

@Component({
    selector: 'app-user-orgs-slideout-wrapper',
    template: '',
    standalone: false
})
export class UserOrgsSlideoutWrapperComponent implements OnInit, OnDestroy {

  slideoutOptions: NgbOffcanvasOptions = {
    backdrop: false,
    animation: true,
    ariaLabelledBy: 'user-organisations-slideout',
    position: 'end',
    scroll: true,
  };

  private slideoutRef!: NgbOffcanvasRef;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private usersAdminService: UsersAdminService,
              protected slideoutService: NgbOffcanvas) { }

  ngOnInit() {
    this.slideoutRef = this.slideoutService.open(UserOrgsSlideoutComponent, this.slideoutOptions);
    const slideoutComponent = this.slideoutRef.componentInstance as UserOrgsSlideoutComponent;

    this.route.paramMap
      .pipe(
        tap(() => { slideoutComponent.loading = true; }),
        map(params => params.get('userId')),
        filter(userId => userId != null),
        switchMap(userId => this.usersAdminService.getUser(userId!)))
      .subscribe(user => {
        slideoutComponent.user = user;
        slideoutComponent.loading = false;
    })

    this.slideoutRef.result.then(
      () => {
        // when closed, navigate back to the user list
        this.router.navigate(['../..'], { relativeTo: this.route }).then();
      },
      // when dismissed, do not change the route, as the user must have navigated somewhere themselves
      () => {}
    )
  }

  ngOnDestroy() {
    this.slideoutRef.dismiss();
  }
}
